// Lecciones de los cursos de Academy en «Mi aprendizaje».
//
// La lista pública de cursos (GET /academy/courses/public) le quita a cada lección su `videoUrl` y su
// `fileUrl` (`getPublishedCourses`, «Strip lesson content for list view»). Con solo esa lista el asesor veía
// los títulos y «Marcar hecha», pero no podía ver ningún video ni abrir ningún documento. El detalle
// (GET /academy/courses/public/by-id/:id) sí los trae: aquí se junta uno con otro.

/** URL para incrustar un video de YouTube o Vimeo en un <iframe>, o null si no es de esos. */
export function urlIncrustable(url) {
  if (!url || typeof url !== 'string') return null
  const yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/)
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0&modestbranding=1`
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`
  return null
}

/** El enlace de una lección: el video, o el archivo/documento. */
export function enlaceDeLeccion(leccion) {
  return leccion?.videoUrl || leccion?.fileUrl || ''
}

/**
 * Cursos de la lista con el temario del detalle, cuando lo hay. Si el detalle de un curso no llegó
 * (red, curso despublicado), queda el temario de la lista: se siguen viendo los títulos.
 * `detalles` es un arreglo de cursos completos (o null) en cualquier orden.
 */
export function conDetalle(cursos, detalles) {
  const porId = new Map((detalles || []).filter(Boolean).map((d) => [d.id, d]))
  return (cursos || []).map((c) => {
    const d = porId.get(c.id)
    return d?.curriculum ? { ...c, curriculum: d.curriculum } : c
  })
}
